/**
 * RenewExpiredSession Component:
 *
 * This component renew the expired security session /api/session.
 *
 */

import { connect } from 'react-redux';
import { useEffect } from 'react';
import { mapStateToProps, mapDispatchToProps } from '../Store';

const RenewExpiredSession = ({ session, actions }) => {
    if (session?.ready && !session?.expires_in) {
        return null;
    }

    useEffect(() => {
        const reloadInterval = setInterval(() => {
            actions.sessionActions.getSession();
            console.log('🔄️ Renew: expired session');
        }, session?.expires_in * 1000);

        // Clear the interval when the component unmounts
        return () => clearInterval(reloadInterval);
    }, []);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(RenewExpiredSession);
